import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Loader2, Users, UserSearch, FileBarChart } from 'lucide-react';
import { newsFeedAPI } from '../../lib/api';
import { ReactionCounts } from './reactions';

const Row = ({ label, value }) => (
  <div className="flex justify-between text-sm py-1">
    <span className="text-slate-500">{label}</span>
    <span className="font-semibold text-slate-900">{value}</span>
  </div>
);

const GroupCard = ({ title, icon: Icon, data, isEmployee, testId }) => (
  <Card className="border-slate-200" data-testid={testId}>
    <CardHeader className="pb-2">
      <CardTitle className="text-base flex items-center gap-2"><Icon className="w-4 h-4 text-cyan-600" /> {title}</CardTitle>
    </CardHeader>
    <CardContent>
      {isEmployee && <Row label="Destinatários (soma)" value={data.destinatarios} />}
      <Row label="Visualizações" value={data.visualizaram} />
      {isEmployee && <Row label="% Visualização" value={`${data.taxa_visualizacao}%`} />}
      <Row label="Reações" value={data.reagiram} />
      <Row label="% Engajamento" value={`${data.taxa_engajamento}%`} />
      <div className="pt-2"><ReactionCounts reacoes={data.reacoes} testIdPrefix={`${testId}-reacoes`} /></div>
    </CardContent>
  </Card>
);

export const EngagementStatsPanel = ({ onOpenReport }) => {
  const [stats, setStats] = useState(null);
  useEffect(() => { newsFeedAPI.getEngagementStats().then((r) => setStats(r.data)).catch(() => setStats(false)); }, []);

  if (stats === null) return <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-cyan-600" /></div>;
  if (stats === false) return <p className="py-8 text-center text-slate-500">Erro ao carregar estatísticas</p>;

  return (
    <div className="space-y-4" data-testid="engagement-stats-panel">
      <div className="grid md:grid-cols-2 gap-4">
        <GroupCard title="Funcionários" icon={Users} data={stats.funcionarios} isEmployee testId="stats-funcionarios" />
        <GroupCard title="Candidatos" icon={UserSearch} data={stats.candidatos} testId="stats-candidatos" />
      </div>
      <Card className="border-slate-200">
        <CardHeader className="pb-2"><CardTitle className="text-base">Por comunicado ({stats.total_comunicados})</CardTitle></CardHeader>
        <CardContent className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="stats-por-comunicado">
            <thead className="text-xs text-slate-500">
              <tr>
                <th className="text-left p-2">Comunicado</th>
                <th className="text-right p-2">Func. visualizaram</th>
                <th className="text-right p-2">Func. engajamento</th>
                <th className="text-right p-2">Cand. visualizaram</th>
                <th className="text-right p-2">Cand. reações</th>
                <th className="p-2" />
              </tr>
            </thead>
            <tbody>
              {stats.por_comunicado.map((c) => (
                <tr key={c.id} className="border-t">
                  <td className="p-2 font-medium text-slate-900">{c.titulo}</td>
                  <td className="p-2 text-right">{c.funcionarios.visualizaram}/{c.funcionarios.total_destinatarios} ({c.funcionarios.taxa_visualizacao}%)</td>
                  <td className="p-2 text-right">{c.funcionarios.reagiram} ({c.funcionarios.taxa_engajamento}%)</td>
                  <td className="p-2 text-right">{c.candidatos.visualizaram}</td>
                  <td className="p-2 text-right">{c.candidatos.reagiram}</td>
                  <td className="p-2 text-right">
                    <Button variant="ghost" size="sm" onClick={() => onOpenReport(c.id)} data-testid={`stats-relatorio-btn-${c.id}`}>
                      <FileBarChart className="w-4 h-4 mr-1" /> Relatório
                    </Button>
                  </td>
                </tr>
              ))}
              {stats.por_comunicado.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-slate-500">Nenhum comunicado publicado</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};
